import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  epcApplications: drilldownData["epcApplications"].map(({ fieldName, placeholder, name, formType, validation, className, options, editable, loadOptions, showField, hidden, futureDateRestriction }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    options: options,
    editable: editable,
    loadOptions: loadOptions,
    showField: showField,
    hidden: hidden,
    futureDateRestriction: futureDateRestriction
  })),
  enquiries: drilldownData["enquiries"].map(({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
  })),
  enquiriesEmailTemplate: drilldownData["enquiriesEmailTemplate"].map(({ fieldName, placeholder, name, formType, validation, className,editable }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    editable: editable
  })),
};
